import React, { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import Cropper from "react-easy-crop";
import { apiClient } from "../utils/const";

const AddCustomer = ({ onClose }) => {
  const [schemeType, setSchemeType] = useState(localStorage.getItem("schemeType")?.toLowerCase());

  // Listen for scheme changes
  useEffect(() => {
    const handleSchemeChange = (event) => {
      const newScheme = event?.detail?.to?.toLowerCase() || (localStorage.getItem("schemeType") && localStorage.getItem("schemeType").toLowerCase()) || "mandal";
      setSchemeType(newScheme);
    };

    // initialize from current storage on mount as well
    const current = (localStorage.getItem("schemeType") && localStorage.getItem("schemeType").toLowerCase()) || "mandal";
    setSchemeType(current);

    window.addEventListener("schemeChanged", handleSchemeChange);
    return () => window.removeEventListener("schemeChanged", handleSchemeChange);
  }, []);
  const [formData, setFormData] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    phone: "",
    email: "",
    monthly_amount: "",
    created_at: "",
    scheme_name: "",
    scheme_id: "",
    address: "",
    card_no: "",
    pan_card: null,
    aadhar_front: null,
    aadhar_back: null,
  });

  const [previews, setPreviews] = useState({
    pan_card: null,
    aadhar_front: null,
    aadhar_back: null,
  });

  const [cropConfig, setCropConfig] = useState({
    show: false,
    field: "",
    image: null,
    crop: { x: 0, y: 0 },
    zoom: 1,
    croppedAreaPixels: null,
    aspect: 1.6,
  });

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      created_at: new Date().toISOString().split("T")[0],
    }));
  }, []);

  useEffect(() => {
    return () => {
      if (cropConfig.image) URL.revokeObjectURL(cropConfig.image);
      Object.values(previews).forEach((u) => u && URL.revokeObjectURL(u));
    };
  }, [cropConfig.image, previews]);

  const getUserAPI = () =>
    schemeType === "mandal"
      ? "/mandal/mandal_create_users.php"
      : "/kanchan/kanchan_create_users.php";
  const handleSchemeChange = (value) => {
    let id = "";
    if (value === "(9+1)Gold Scheme") id = 1;
    else if (value === "(12+2)Gold Scheme") id = 2;

    setFormData((prev) => ({ ...prev, scheme_name: value, scheme_id: id }));
  };

  const handleImageChange = (field, file) => {
    if (!file) return;
    const url = URL.createObjectURL(file);

    setCropConfig({
      show: true,
      field,
      image: url,
      crop: { x: 0, y: 0 },
      zoom: 1,
      croppedAreaPixels: null,
      aspect:1.6,
    });
  };

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCropConfig((prev) => ({ ...prev, croppedAreaPixels }));
  }, []);

  const createImage = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = url;
    });

  const getUniqueFileName = () => {
    const timestamp = Math.floor(Date.now() / 1000);
    const randomNum = Math.floor(100000 + Math.random() * 900000);
    return `kanchan_${timestamp}_${randomNum}.jpg`;
  };

  const getCroppedImg = async (imageSrc, cropped) => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = Math.round(cropped.width);
    canvas.height = Math.round(cropped.height);

    ctx.drawImage(
      image,
      cropped.x,
      cropped.y,
      cropped.width,
      cropped.height,
      0,
      0,
      canvas.width,
      canvas.height
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        const file = new File([blob], getUniqueFileName(), { type: "image/jpeg" });
        resolve({ file, url: URL.createObjectURL(blob) });
      }, "image/jpeg", 0.92);
    });
  };

  const resetCropper = () =>
    setCropConfig({
      show: false,
      field: "",
      image: null,
      crop: { x: 0, y: 0 },
      zoom: 1,
      croppedAreaPixels: null,
      aspect: 1.6,
    });

  const handleCropSave = async () => {
    if (!cropConfig.croppedAreaPixels) return;
    const { file, url } = await getCroppedImg(
      cropConfig.image,
      cropConfig.croppedAreaPixels
    );

    setFormData((prev) => ({ ...prev, [cropConfig.field]: file }));
    setPreviews((prev) => {
      const old = prev[cropConfig.field];
      if (old) URL.revokeObjectURL(old);
      return { ...prev, [cropConfig.field]: url };
    });

    if (cropConfig.image) URL.revokeObjectURL(cropConfig.image);
    resetCropper();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const apiUrl = getUserAPI();

    try {
      const payload = new FormData();
      payload.append("first_name", formData.first_name);
      payload.append("middle_name", formData.middle_name);
      payload.append("last_name", formData.last_name);
      payload.append("phone", formData.phone);
      payload.append("email", formData.email);
      payload.append("card_no", formData.card_no);

      if (schemeType === "mandal") {
        payload.append("scheme_type", formData.scheme_name);
        payload.append("monthly_amount", parseInt(formData.monthly_amount));
        payload.append("address", formData.address);
      }

      if (schemeType === "kanchan") {
        payload.append("scheme_id", formData.scheme_id);
        payload.append("pan_card", formData.pan_card);
        payload.append("aadhar_front", formData.aadhar_front);
        payload.append("aadhar_back", formData.aadhar_back);
      }

      const res = await apiClient.post(apiUrl, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      // console.log(res.data);
      const result = res.data;
      if (result?.message === 'radha') {
        toast.success("Customer added successfully!");
        onClose?.();
      } else {
        toast.error("Error adding customer");
      }
    } catch (error) {
      toast.error("Request failed: " + error.message);
    }
  };

  return (
    <>
      {/* Cropper Modal */}
      {cropConfig.show && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ background: "rgba(0,0,0,0.7)", zIndex: 9999 }}
        >
          <div
            className="bg-white p-3 rounded-3 shadow"
            style={{
              width: "90%",
              maxWidth: 640,
              position: "relative",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                height: 360,
                overflow: "hidden",
                borderRadius: "0.5rem",
              }}
            >
              <Cropper
                image={cropConfig.image}
                crop={cropConfig.crop}
                zoom={cropConfig.zoom}
                aspect={cropConfig.aspect}
                onCropChange={(crop) =>
                  setCropConfig((prev) => ({ ...prev, crop }))
                }
                onZoomChange={(zoom) =>
                  setCropConfig((prev) => ({ ...prev, zoom }))
                }
                onCropComplete={onCropComplete}
                restrictPosition={false}
                showGrid
              />
            </div>

            <div className="d-flex align-items-center justify-content-end gap-2 mt-3">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={resetCropper}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleCropSave}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {/* -------------- Main Form --------------- */}
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="row g-3">
          {/* Name fields */}
          <div className="col-md-4">
            <label className="form-label">
              First Name <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              value={formData.first_name}
              onChange={(e) =>
                setFormData({ ...formData, first_name: e.target.value })
              }
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Middle Name (Parent's Name)</label>
            <input
              className="form-control"
              value={formData.middle_name}
              onChange={(e) =>
                setFormData({ ...formData, middle_name: e.target.value })
              }
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">
              Last Name <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              value={formData.last_name}
              onChange={(e) =>
                setFormData({ ...formData, last_name: e.target.value })
              }
              required
            />
          </div>

          {/* Card No - Common for both schemes */}
          <div className="col-md-4">
            <label className="form-label">
              Card No <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              value={formData.card_no}
              onChange={(e) =>
                setFormData({ ...formData, card_no: e.target.value })
              }
            />
          </div>

          {/* Mandal form */}
          {schemeType === "mandal" && (
            <>
              <div className="col-md-4">
                <label className="form-label">
                  Phone <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  value={formData.phone}
                  onChange={(e) =>
                    setFormData({ ...formData, phone: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Email</label>
                <input
                  className="form-control"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4 d-flex flex-column" style={{ gridRow: "span 2" }}>
                <label className="form-label">Address</label>
                <textarea
                  className="form-control flex-grow-1"
                  value={formData.address}
                  onChange={(e) =>
                    setFormData({ ...formData, address: e.target.value })
                  }
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Monthly Amount <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="number"
                  placeholder="Monthly Amount"
                  value={formData.monthly_amount}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData({
                      ...formData,
                      monthly_amount: value,
                    });
                  }}
                />
              </div>
              {/* <div className="col-md-4">
                <label className="form-label">Bonus</label>
                <input
                  className="form-control"
                  type="text"
                  value={formData.bonus}
                  readOnly
                />
              </div> */}
            </>
          )}

          {/* Kanchan form */}
          {schemeType === "kanchan" && (
            <>
              <div className="col-md-4">
                <label className="form-label">
                  Phone <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  value={formData.phone}
                  onChange={(e) =>
                    setFormData({ ...formData, phone: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Email</label>
                <input
                  className="form-control"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">
                  Scheme <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  value={formData.scheme_name}
                  onChange={(e) => handleSchemeChange(e.target.value)}
                  required
                >
                  <option value="">-- Select Scheme --</option>
                  <option value="(9+1)Gold Scheme">(9+1)Gold Scheme</option>
                  <option value="(12+2)Gold Scheme">(12+2)Gold Scheme</option>
                </select>
              </div>

              <div className="col-12" />

              {/* Kanchan uploads */}
              <div className="col-md-4">
                <label className="form-label">PAN Card</label>
                <input
                  className="form-control"
                  type="file"
                  accept="image/*"
                  capture="environment"
                  onChange={(e) =>
                    handleImageChange("pan_card", e.target.files[0])
                  }
                />
                {previews.pan_card && (
                  <img
                    src={previews.pan_card}
                    alt="PAN Preview"
                    className="img-fluid mt-2 border rounded"
                  />
                )}
              </div>
              <div className="col-md-4">
                <label className="form-label">Aadhaar Card (Front)</label>
                <input
                  className="form-control"
                  type="file"
                  accept="image/*"
                  capture="environment"
                  onChange={(e) =>
                    handleImageChange("aadhar_front", e.target.files[0])
                  }
                />
                {previews.aadhar_front && (
                  <img
                    src={previews.aadhar_front}
                    alt="Aadhaar Front Preview"
                    className="img-fluid mt-2 border rounded"
                  />
                )}
              </div>
              <div className="col-md-4">
                <label className="form-label">Aadhaar Card (Back)</label>
                <input
                  className="form-control"
                  type="file"
                  accept="image/*"
                  capture="environment"
                  onChange={(e) =>
                    handleImageChange("aadhar_back", e.target.files[0])
                  }
                />
                {previews.aadhar_back && (
                  <img
                    src={previews.aadhar_back}
                    alt="Aadhaar Back Preview"
                    className="img-fluid mt-2 border rounded"
                  />
                )}
              </div>
            </>
          )}
        </div>

        <div className="d-flex justify-content-end mt-4">
          <button className="btn btn-primary px-4" type="submit">
            Add User
          </button>
        </div>
      </form>
    </>
  );
};

export default AddCustomer;
